export default {
  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies / Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants / Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear / Underpants',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',
};